import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/app/[locale]/error.tsx");
